import { Canvas } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";

import { GridContainerBlock, GridItemBlock, LinkBlock, UnsubscribeFeedbackTitleBlock } from "../..";
import BasePreview from "../../base";

function UnsubscribeFeedbackPreview({ ...props }) {
  return <BasePreview {...props}>
    <div>
      <Canvas
        id="grid-container"
        is={GridContainerBlock}
        properties={{ layoutType: 'grid', grid: { columns: 1, rows: 2, height: 'fitcontent', gap: { all: '6-predefined' } }, size: { width: 'w-full' } }}
        custom={{ name: 'Grid' }}>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Heading' }}>
          <Canvas
            is={UnsubscribeFeedbackTitleBlock}
            custom={{ name: 'Feedback Title' }} />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Link' }}>
          <Canvas
            is={LinkBlock}
            properties={{ content: "Visit our site", url: "/", textAlign: { horizontal: 'center' }, size: { width: 'w-full' }, textColor: 'blue-500', className: 'cursor-pointer' }} />
        </Canvas>
      </Canvas>
    </div>
  </BasePreview>
}

export default define('unsubscribe-feedback', UnsubscribeFeedbackPreview)
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.layout())
  .defaultProps({
    size: { width: 'w-full' },
  })
  .build()
